import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from '../../actions/user_actions';
import * as SettingScreen from '../../actions/settingScreen_actions';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import { validate } from '../../validations';
import { ModalDialogCommon } from '../modal_dialog_common';
import settingsScreen from './settingsScreen';


let ChangePassword = React.createClass({
    getInitialState() {
        return {
            isDeleting: false,
            oldPass: "",
            shouldHide: true,
            fields: true,
            confirmPass: true,
            succesPass: false,
            wrongoldpassword: false,
            errorMessage: null,
            okModalMessage: null,
            isVerifyOldPasswordSubmitted: null,
            isChangePasswordSubmitted: null,
            isVerifyOtpSubmitted: null,
            invalidOTPErrorMsg: null
        }
    },
    componentWillReceiveProps(nextProps) {

        // Password Verification Response
        if (this.state.isVerifyOldPasswordSubmitted) {
            if (nextProps.VerifyPasswordResponse && nextProps.VerifyPasswordResponse.status == 200) {

                if (this.state.isVerifyOtpSubmitted && nextProps.otpResponseData && nextProps.otpResponseData.status === 200) {
                    nextProps.VerifyPasswordResponse.status = "";
                    this.setState({ okModalMessage: null });
                    var data = {
                        "id": this.props.LogingDetails.data.id,
                        "uniqueKey": this.props.LogingDetails.data.uniqueKey,
                        "password": this.refs.confirmPassword.value,
                        "isPasswordChange": 0
                    };
                    this.setState({ isChangePasswordSubmitted: true, isVerifyOtpSubmitted: false })
                    this.props.Dispatch(SettingScreen.changePassword(data));
                    this.setState({ isVerifyOldPasswordSubmitted: null });
                    this.refs.oldPassword.value = '';
                    this.refs.newPassword.value = '';
                    this.refs.confirmPassword.value = '';


                } else if (this.state.isVerifyOtpSubmitted && nextProps.otpResponseData && nextProps.otpResponseData.status !== 200) {
                    this.setState({ invalidOTPErrorMsg: nextProps.otpResponseData.message })
                }

            } else if (nextProps.VerifyPasswordResponse) {
                //alert(nextProps.VerifyPasswordResponse.message ); // need to check the Modal is not opening.
                this.setState({ okModalMessage: nextProps.VerifyPasswordResponse.message })
            }
        }

        if (this.state.isChangePasswordSubmitted) {
            this.setState({ isChangePasswordSubmitted: null });

            // need to validate the ChanagePassword Response
            if (nextProps.Settings.Changepassword.status === 200) {
                this.setState({ okModalMessage: nextProps.Settings.Changepassword.message });
            }
            else {
                this.setState({ okModalMessage: nextProps.Settings.Changepassword.message })
            }

            this.setState({ isChangePasswordSubmitted: null });
        }

    },
    Submit() {
        if (this.refs.oldPassword.value != "" && this.refs.newPassword.value != "" && this.refs.confirmPassword.value != "") {
            if (this.refs.newPassword.value == this.refs.confirmPassword.value) {
                var PassCheck = {
                    "id": this.props.LogingDetails.data.id,
                    "uniqueKey": this.props.LogingDetails.data.uniqueKey,
                    "password": this.refs.oldPassword.value
                }

                this.setState({
                    oldPass: this.refs.oldPassword.value,
                    confirmPass: true, fields: true,

                })
                this.props.Dispatch(SettingScreen.verifyPass(PassCheck));
            } else {
                this.setState({
                    fields: true,
                    confirmPass: false
                })
            }
        } else {
            this.setState({
                fields: false
            })
        }
    },
    removeCancelPrompt() {
        // this.props.router.push('/settingsScreen')
        this.props.Dispatch(SettingScreen.resetOTPData());
        this.props.Dispatch(UserActions.otpSuccess(null));

        this.setState({ isDeleting: false, isVerifyOtpSubmitted: false, isVerifyOldPasswordSubmitted: false }, () => {
            console.log(this.state)
        })

    },
    confirmPrompt() {

        var data = {
            "id": this.props.LogingDetails.data.id,
            "uniqueKey": this.props.LogingDetails.data.uniqueKey,
            "password": this.refs.confirmPassword.value,
            "isPasswordChange": 0
        }
        this.props.Dispatch(SettingScreen.changePassword(data));
        this.setState({
            isDeleting: false
        })
        this.refs.oldPassword.value = "";
        this.refs.confirmPassword.value = "";
        this.refs.newPassword.value = "";
        this.setState({
            fields: true,
            confirmPass: true,
            succesPass: true
        })

        this.props.router.push('/')
    },

    oK() {

        var data = {
            "id": this.props.LogingDetails.data.id,
            "uniqueKey": this.props.LogingDetails.data.uniqueKey,
            "password": this.refs.confirmPassword.value,
            "isPasswordChange": 0
        }
        this.props.Dispatch(SettingScreen.changePassword(data));
        this.setState({
            isDeleting: false
        })
        this.refs.oldPassword.value = "";
        this.refs.confirmPassword.value = "";
        this.refs.newPassword.value = "";
        this.setState({
            fields: true,
            confirmPass: true,

        })

        this.setState({
            succesPass: false
        })
        this.props.router.push('/')
    },
    clear() {
        this.setState({
            fields: true,
            confirmPass: true
        })
    },

    updateChangePassword() {

        if (this.isValideChangePasswordDetails()) {

            // old passwor verification
            var PassCheck = {
                "id": this.props.LogingDetails.data.id,
                "uniqueKey": this.props.LogingDetails.data.uniqueKey,
                "password": this.refs.oldPassword.value
            }
            this.setState({
                isVerifyOldPasswordSubmitted: true,
            });
            this.props.Dispatch(SettingScreen.verifyPass(PassCheck));

        }

    },

    isValideChangePasswordDetails() {

        let isValidateOldPassword = validate.notEmpty(this.refs.oldPassword.value);
        isValidateOldPassword ? this.refs.oldPassword.className = 'inputText' : this.refs.oldPassword.className = 'inputText error';

        let isValidNewPassword = validate.isValidPassword(this.refs.newPassword.value.trim());
        isValidNewPassword ? this.refs.newPassword.className = 'inputText' : this.refs.newPassword.className = 'inputText error';

        let isValidConfirmPassword = validate.isValidPassword(this.refs.confirmPassword.value.trim());
        isValidConfirmPassword ? this.refs.confirmPassword.className = 'inputText' : this.refs.confirmPassword.className = 'inputText error';

        if (!isValidateOldPassword) {
            this.setState({
                errorMessage: "Please enter necessary fields to proceed."
            });
            return false;
        }

        if (!isValidNewPassword || !isValidConfirmPassword) {
            this.setState({
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            });
            return false;
        }

        let isPasswordMatched = false;
        if (this.refs.newPassword.value == this.refs.confirmPassword.value) {
            isPasswordMatched = true;
            this.setState({
                errorMessage: null,
            });
        } else {
            isPasswordMatched = false;
            this.setState({
                errorMessage: "Password and verify password should match."
            })
            this.refs.confirmPassword.className = 'inputText error';
            return false;
        }

        if (isValidateOldPassword && isValidNewPassword && isValidConfirmPassword && isPasswordMatched) {
            this.setState({
                errorMessage: null,
            });

            return true;
        }
    },

    validateOldPassword() {
        let isValidateOldPassword = validate.notEmpty(this.refs.oldPassword.value);
        isValidateOldPassword ? this.refs.oldPassword.className = 'inputText' : this.refs.oldPassword.className = 'inputText error';
        if (!isValidateOldPassword) {
            this.setState({
                errorMessage: "Please enter necessary fields to proceed."
            })
        }
        else {
            this.setState({
                errorMessage: null,
            })
        }
        return isValidateOldPassword
    },

    validateNewPassword() {

        let isValidpassword = validate.isValidPassword(this.refs.newPassword.value.trim());
        isValidpassword ? this.refs.newPassword.className = 'inputText' : this.refs.newPassword.className = 'inputText error';
        if (isValidpassword) {
            this.setState({
                errorMessage: null,
            })
        } else {
            this.setState({
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            })
        }
        return isValidpassword;
    },

    validateConfirmPassword() {

        let isValidConfirmpassword = validate.isValidPassword(this.refs.confirmPassword.value.trim());
        isValidConfirmpassword ? this.refs.confirmPassword.className = 'inputText' : this.refs.confirmPassword.className = 'inputText error';
        if (!isValidConfirmpassword) {
            this.setState({
                newPassword: null,
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            });
            return false;
        }
        if (isValidConfirmpassword && (this.refs.newPassword.value == this.refs.confirmPassword.value)) {
            this.setState({
                newPassword: this.refs.newPassword.value,
                errorMessage: null,
            })
            return true;
        }
        else {
            this.setState({
                newPassword: null,
                errorMessage: "Password and verify password should match."
            })
            this.refs.confirmPassword.className = 'inputText error';
            return false;
        }
    },

    remove_error(event) {
        event.target.className = 'inputText';
    },
    closeOkModal() {
        this.setState({ okModalMessage: null, isVerifyOldPasswordSubmitted: false, isVerifyOtpSubmitted: false });
        this.props.Dispatch(UserActions.otpSuccess(null));
        if (this.props.Settings && this.props.Settings.Changepassword && this.props.Settings.Changepassword.status === 200) {
            this.props.Dispatch(UserActions.logout(
                {
                    "appType": "WEB",
                    "id": this.props.LogingDetails && this.props.LogingDetails.data && this.props.LogingDetails.data.id
                }
            ));
            this.props.Dispatch(UserActions.user_log_out());
        }
        // this.refs.oldPassword.value = "";
        // this.refs.newPassword.value = "";
        // this.refs.confirmPassword.value = "";

    },
    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.Dispatch(SettingScreen.verifyOTP({
                "otp": this.refs.otp.value,
                "id": this.props.LogingDetails.data.id,
                "deviceKey": this.props.LogingDetails.data.deviceKey
            }))

        }
    },
    sendOTP() {
        this.setState({ isVerifyOtpSubmitted: true, invalidOTPErrorMsg: null });
        this.props.Dispatch(SettingScreen.getOTP({
            id: this.props.LogingDetails.data.id,
            email: this.props.LogingDetails.data.email,
            "uniqueKey": this.props.LogingDetails.data.uniqueKey,
            "deviceKey": this.props.LogingDetails.data.deviceKey
        }));
        this.props.Dispatch(UserActions.otpSuccess(null));
    },
    togglePassword() {
        var pwd = document.getElementById("oldPassword");
        pwd.type === "password" ? pwd.type = "text" : pwd.type = "password";
    },
    toggleNewPassword() {
        var confirmPwd = document.getElementById("newPassword");
        confirmPwd.type === "password" ? confirmPwd.type = "text" : confirmPwd.type = "password";
    },
    toggleVerifyPassword() {
        var verifymPwd = document.getElementById("confirmPassword");
        verifymPwd.type === "password" ? verifymPwd.type = "text" : verifymPwd.type = "password";
    },
    render() {
        return (
            <div>
                <div role="tabpanel" className="tab-pane" id="daily">
                    <div className="create-facility">
                        <div className="row">

                            <div className="col-xs-6 no-padding update-profile">
                                <div className="input-group">
                                    <input type="password" className="inputText" ref="oldPassword" id="oldPassword" onFocus={this.remove_error} onBlur={this.validateOldPassword} maxLength="64" required />
                                    <span className="floating-label">Old Password</span>
                                    <img
                                        src={require("./../../images/eye-open.png")}
                                        className="eye-icon"
                                        onClick={() => {
                                            this.togglePassword();
                                        }}
                                    />
                                </div>
                                <div className="input-group">
                                    <input type="password" className="inputText" ref="newPassword" id="newPassword" onFocus={this.remove_error} onBlur={this.validateNewPassword} maxLength="64" required />
                                    {/*<input type="password" className="inputText" ref="newPassword" onChange={this.clear} required />*/}
                                    <span className="floating-label">New Password</span>
                                    <img
                                        src={require("./../../images/eye-open.png")}
                                        className="eye-icon"
                                        onClick={() => {
                                            this.toggleNewPassword();
                                        }}
                                    />
                                </div>
                                <div className="input-group">
                                    <input type="password" className="inputText" ref="confirmPassword" id="confirmPassword" onFocus={this.remove_error} onBlur={this.validateConfirmPassword} maxLength="64" required />
                                    {/*<input type="password" className="inputText" ref="confirmPassword" onChange={this.clear} required />*/}
                                    <span className="floating-label">Verify Password</span>
                                    <img
                                        src={require("./../../images/eye-open.png")}
                                        className="eye-icon"
                                        onClick={() => {
                                            this.toggleVerifyPassword();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {this.state.errorMessage &&
                            <div className="error-message">
                                <span className="red-color">{this.state.errorMessage} </span>
                            </div>}
                        {this.state.isVerifyOldPasswordSubmitted && <Modal isOpen={this.state.isVerifyOldPasswordSubmitted} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                            <div className="popup-content profile OTP_content text-center">
                                {/* <p className='verify_text'>Verify Yourself</p> */}
                                <p className='main_header'>
                                    Are you sure? You'll have to login again.
                                </p>
                                <div>
                                    <input type='button' value='OK' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.sendOTP} />
                                    <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.removeCancelPrompt} />
                                </div>
                            </div>
                        </Modal>}
                        {this.state.isVerifyOtpSubmitted && this.props.VerifyPasswordResponse && this.props.VerifyPasswordResponse.status === 200 && <Modal isOpen={this.state.isVerifyOtpSubmitted} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>                            <div className="popup-content profile OTP_content text-center">
                            <p className='verify_text'>Verify Yourself</p>
                            <p className='main_header'>

                                {/* We just sent you an XXXX digit code to {this.props.LogingDetails.data.email}.
                                    Please enter the code below. */}
                                    We just sent you an XXXX digit code to your registered Email ID. Please enter the code below.
                                </p>
                            <div>
                                <div className="input-group">
                                    <input type='text' ref='otp' className="inputText opt_Textbox" onKeyPress={this.handleKeyPress} required maxLength={4} />
                                    <span className="floating-label Otp_label">OTP</span>
                                    {this.state.invalidOTPErrorMsg &&
                                        <div className="error-message">
                                            <span className="red-color">{this.state.invalidOTPErrorMsg} </span>
                                        </div>}
                                </div>
                                <input type='button' value='CONFIRM' className='button button-primary btn-submit gray-button' ref='deleteBtn' onClick={() => {
                                    this.props.Dispatch(SettingScreen.verifyOTP({
                                        "otp": this.refs.otp.value,
                                        "id": this.props.LogingDetails.data.id,
                                        "deviceKey": this.props.LogingDetails.data.deviceKey
                                    }));
                                }} />
                                <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.removeCancelPrompt} />
                            </div>
                        </div>
                        </Modal>}

                        {this.state.okModalMessage && <ModalDialogCommon message={this.state.okModalMessage} action={this.closeOkModal} />}
                        {/*<div className="error-message">

                            <span className={this.state.fields ? 'hidden' : ''} >Please enter mandatory field</span>
                            <span className={this.state.confirmPass ? 'hidden' : ''} >confirmed password is not matching the new password</span>
                            <span className={!(this.state.wrongoldpassword && this.state.confirmPass) ? 'hidden' : ''} >Incorrect old Password</span>
                        </div>*/}
                        <button className="gray-button change-pass" data-toggle="modal" data-target="#settings_change" onClick={this.updateChangePassword}>Change Password</button>
                    </div>
                </div>


                {/*<Modal ref='deleteAddressModal' isOpen={this.state.succesPass} className='delete-prompt modalPopup' contentLabel='modalPopup'>
                    <div className="popup-content text-center changed-pwd">
                        <p className='main_header'>
                            Password changed successfully.
                        </p>
                        <input type='button' value='OK' className='button button-primary btn-submit gray-button' onClick={this.oK} />
                    </div>
                </Modal>*/}


            </div >
        );
    }
});

let mapStateToProps = (state) => {
    return {
        LogingDetails: state.User.loginData,
        Res: state.Setting.Changepassword,
        Settings: state.Setting,
        VerifyPasswordResponse: state.Setting.verification,
        VerifyOTPResponse: state.Setting.otpResponseData,
        otpResponseData: state.User.OTPResponse

    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    SettingScreen: bindActionCreators(SettingScreen, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(ChangePassword));



/** WEBPACK FOOTER **
 ** ./src/components/settingsScreen/changePassword.js
 **/